import { Body, FeaturedBannerContainer, Headline, StyledAvatar } from './LlistingProfile.style'

import { useState } from 'react'
import { Image } from 'components/generic/HomePageComponents'
import Modal from 'components/generic/Modal'
import { OnlineNowDot } from 'components/generic/Styled'
import { Box } from '@careguide/theme'
import FeaturedBanner from 'components/base/FeaturedBanner'
import { isOnlineNow } from 'utils/dateUtils'
import ExperienceRate from '../ExperienceRate'
import Location from '../Location'
import Stack from '@careguide/stack'
import { Heading, Body as BodyCopy } from '@careguide/typography'
import { DateFromNowFormatEnum, getLastActiveStatus } from 'utils/dateUtils'

const ListingProfile = ({ listing }: TODO) => {
  const { user, featured, name: headline, city, state, avatar } = listing
  const [showModal, setShowModal] = useState(false)

  const isOnline = isOnlineNow(user?.lastOnline)
  const isDefaultAvatar = avatar?.isDefault
  const breadcrumbs = listing.breadcrumbs

  const onAvatarClicked = () => !isDefaultAvatar && setShowModal(true)
  const onCloseAvatarModel = () => setShowModal(false)

  return (
    <Box display='flex' flexDirection='column' color='gray.6'>
      <Stack gap='4'>
        {featured && (
          <FeaturedBannerContainer>
            <FeaturedBanner />
          </FeaturedBannerContainer>
        )}
        <Body>
          <Stack gap='4'>
            <StyledAvatar
              isDefaultAvatar={isDefaultAvatar}
              url={avatar.mediumUrl}
              altText={isDefaultAvatar ? '' : 'Profile photo'}
              onClick={onAvatarClicked}
              width='128px'
              height='128px'
            />
            <Modal onCloseModal={onCloseAvatarModel} showModal={showModal} shouldCloseOnEsc={true}>
              <Image
                width={{ _: '275px', tablet: '500px', desktop: '500px' }}
                height='auto'
                borderRadius='5px'
                src={avatar.largeUrl}
                alt={user.fullName}
              />
            </Modal>

            <Box>
              <Heading as='h2'>{user.fullName}</Heading>
            </Box>
            <Stack gap='6'>
              <Headline>{headline}</Headline>

              <Stack gap='2'>
                <Location breadcrumbs={breadcrumbs} city={city?.name} state={state?.name} />
                <Stack direction='horizontal' align='center' gap='1'>
                  {isOnline && <OnlineNowDot aria-hidden />}
                  <BodyCopy size='0' color='gray.5'>
                    {getLastActiveStatus(user?.lastOnline, DateFromNowFormatEnum.LONG)}
                  </BodyCopy>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Body>
        <ExperienceRate {...listing} />
      </Stack>
    </Box>
  )
}

export default ListingProfile
